export enum ScreenAddFormFields {
  Name = 'name',
}
